import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getFailedToExportReports } from './errorMessages';
import contentDisposition from 'content-disposition';
import { ITEM_ANALYSES } from '@instructure/quiz-common';
export var exportReports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var getAnalysesExport, activeQuizId, filter, format, saveFile, addError, _ref$analysisType, analysisType, response, dispositionHeader, disposition, filename, blob;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getAnalysesExport = _ref.getAnalysesExport, activeQuizId = _ref.activeQuizId, filter = _ref.filter, format = _ref.format, saveFile = _ref.saveFile, addError = _ref.addError, _ref$analysisType = _ref.analysisType, analysisType = _ref$analysisType === void 0 ? ITEM_ANALYSES : _ref$analysisType;
          _context.prev = 1;
          _context.next = 4;
          return getAnalysesExport(activeQuizId, format, filter, analysisType);
        case 4:
          response = _context.sent;
          dispositionHeader = response.headers.get('Content-Disposition');
          if (dispositionHeader) {
            _context.next = 8;
            break;
          }
          throw new Error('Response contains no Content-Disposition header.');
        case 8:
          disposition = contentDisposition.parse(dispositionHeader);
          filename = disposition.parameters.filename;
          if (filename) {
            _context.next = 12;
            break;
          }
          throw new Error('Cannot determine filename to save.');
        case 12:
          _context.next = 14;
          return response.blob();
        case 14:
          blob = _context.sent;
          saveFile(blob, filename);
          _context.next = 21;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](1);
          addError(getFailedToExportReports());
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 18]]);
  }));
  return function exportReports(_x) {
    return _ref2.apply(this, arguments);
  };
}();